import { types, actions } from './requests'
export const ASSIGNWORK_TYPES = {
    ...types('ASSIGNWORK'),
}
export const ASSIGNWORK_ACTIONS = {
    ...actions('ASSIGNWORK'),
}
